import { Grid, Hidden } from '@material-ui/core';
import { Form, Formik, FormikProps } from 'formik';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { FormField } from '../../../../../global/components/form-element/form-field';
import { NumberField, NumberInputTypes } from '../../../../../global/components/form-element/number-field';
import { FormWrapper } from '../../../../../global/components/form-wrapper';
import { GuidedProcessSupportBlock } from '../../../../../global/components/guided-process-support-block';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { FormGroup } from '../../../../../global/components/layout/form-group';
import { PageHeader } from '../../../../../global/components/layout/page-header';
import { SideBarContent } from '../../../../../global/components/layout/sidebar-content';
import { getGpsType } from '../../../../../global/helpers/gps-helper';
import { useApiResponseError } from '../../../../../global/hooks/useApiError';
import { LabelSettingProps } from '../../../../../global/models/epi-model';
import { FormBaseModel } from '../../../../../global/models/page-model';
import { FormTypes } from '../../../../account-info/models/form-models';
import { CompensationProps } from '../../../models/arc-epi-props';
import { OneTimePaymentFormValues, OneTimePaymentValidationSchema } from './one-time-payment-form-model';

interface OneTimeProps extends FormBaseModel {
	onSubmitHandler: (savedValues: OneTimePaymentFormValues, values: OneTimePaymentFormValues) => any;
	compensationProps: CompensationProps;
	labelSettings: LabelSettingProps;
	previousRoute: string;
}
export function OneTimePaymentForm(props: OneTimeProps) {
	const { onSubmitHandler, compensationProps, labelSettings, previousRoute } = props;

	const history = useHistory();
	const apiErrors = useApiResponseError(FormTypes.COMPENSATION);
	const gpsItem = getGpsType(null, null);

	const initialValues: OneTimePaymentFormValues = {
		effective_date: null,
		amount: '0.00',
	};

	return (
		<Formik
			initialValues={initialValues}
			validationSchema={OneTimePaymentValidationSchema(compensationProps, labelSettings)}
			onSubmit={(values) => onSubmitHandler(initialValues, values)}
			enableReinitialize
			initialErrors={apiErrors}
		>
			{(formProps: FormikProps<OneTimePaymentFormValues>) => (
				<Form>
					<Grid>
						<FormWrapper
							formikProps={formProps}
							submitText={labelSettings.submitText}
							cancelText={labelSettings.cancelText}
							onCancel={() => history.push(previousRoute)}
						>
							<PageHeader headerText={props.formHeader} description={props.formDescription} />
							<Hidden mdUp>
								<SideBarContent>
									<GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
								</SideBarContent>
							</Hidden>
							<DividerSection removeDivider>
								<FormGroup>
									<FormField
										name='effective_date'
										label={compensationProps.paymentEffectiveDateLabel}
										component='datePicker'
										touched={formProps.touched}
										errors={formProps.errors}
										required
										autoWidth
									/>
									<NumberField
										type={NumberInputTypes.Currency}
										name='amount'
										label={compensationProps.paymentAmountLabel}
										formikProps={formProps}
										required
									/>
								</FormGroup>
							</DividerSection>

						</FormWrapper>
					</Grid>
				</Form>
			)}
		</Formik>
	);
}